import { apiClient, ApiResult } from "@/lib/api-client"
import { HttpStatusCodes } from "@/lib/http-status-codes"

class LookupService {
    async getStates(): Promise<{ id: string; name: string }[]> {
        const res = await apiClient.get("/lookup/states")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch states")
        }
        return (res.data as ApiResult<{ id: string; name: string }[]>).value
    }

    async getEducationLevels(): Promise<{ id: string; name: string }[]> {
        const res = await apiClient.get("/lookup/education-levels")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch education levels")
        }
        return (res.data as ApiResult<{ id: string; name: string }[]>).value
    }

    async getAllowedVacancyPromptLength(): Promise<{ id: string; code: string, name: string } | null> {
        const res = await apiClient.get("/lookup/vacancy-prompt-length")
        if (!res.status || res.status !== HttpStatusCodes.OK) {
            throw new Error("Failed to fetch vacancy prompt length")
        }
        return (res.data as { id: string; code: string, name: string }) ?? null
    }
}

export const lookupService = new LookupService()

export function useLookupService() {
    return lookupService
}
